import { PLANE } from '@/constants/object';
import * as THREE from 'three';
import { BaseObject, applyGeometryProperty, applyProperties } from './base';

export class Plane extends BaseObject {
  constructor() {
    super(new THREE.PlaneGeometry(PLANE.WIDTH, PLANE.HEIGHT), new THREE.MeshStandardMaterial({ color: PLANE.COLOR }));

    this.width = PLANE.WIDTH;
    this.height = PLANE.HEIGHT;

    this.getOutline();

    this.updateGeometry = () => {
      this.geometry.dispose();
      this.geometry = new THREE.PlaneGeometry(this.width, this.height);
      this.getOutline();
    };

    this.applyProperties = (properties) => {
      applyProperties(this, properties, false);
      const needsUpdate =
        applyGeometryProperty(this, properties.width, 'width', PLANE.MIN_DIMENSION) |
        applyGeometryProperty(this, properties.height, 'height', PLANE.MIN_DIMENSION);

      if (needsUpdate) this.updateGeometry();
    };
  }
}
